import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Home } from './pages/Home';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="35bsdwu4370rn">
      <Home data-id="element-1" data-mp="35eodemvl1xi7" />
    </LanguageProvider>;
}